// src/components/programs/ProgramForm/Step1ProgramData.jsx

import React from "react";
import { Box, Typography, Paper, Grid } from "@mui/material";
import LanguageToggle from "../../global/LanguageToggle";
import useFormLanguage from "../../../hooks/forms/useFormLanguage";

// Import sections
import DayItineraryList from "./Step1Sections/DayItineraryList";
import ProductsPanel from "./Step1Sections/ProductsPanel";

const Step1ProgramData = ({
    formData,
    setFormData,
    errors = {},
    isEdit = false,
    currentData = null
}) => {
    const { isArabic, activeLang, setActiveLang } = useFormLanguage();

    return (
        <Paper sx={{ p: { xs: 2, sm: 3 }, borderRadius: 2 }}>
            {/* Compact Header */}
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 3,
                    pb: 2,
                    borderBottom: 1,
                    borderColor: 'divider',
                }}
            >
                <Box>
                    <Typography variant="h6" sx={{ mb: 0.5, fontWeight: 700, fontSize: '1.1rem' }}>
                        {isArabic ? 'تفاصيل البرنامج' : 'Program Details'}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.85rem' }}>
                        {isArabic
                            ? 'قم بإضافة المنتجات لكل يوم من البرنامج'
                            : 'Add products for each day of the program'}
                    </Typography>
                </Box>

                <LanguageToggle
                    activeLang={activeLang}
                    onChange={(lang) => setActiveLang(lang)}
                    showLabel={true}
                />
            </Box>

            <Grid container spacing={2}>
                {/* Days Itinerary List - Left Side (Sticky) */}
                <Grid item xs={12} md={8}>
                    <Box
                        sx={{
                            position: 'sticky',
                            top: 80, // Adjust based on your navbar height
                            maxHeight: 'calc(100vh - 100px)', // Dynamic height
                            overflow: 'auto',
                            // Custom scrollbar
                            '&::-webkit-scrollbar': {
                                width: '6px',
                            },
                            '&::-webkit-scrollbar-track': {
                                bgcolor: 'transparent',
                            },
                            '&::-webkit-scrollbar-thumb': {
                                bgcolor: 'divider',
                                borderRadius: '3px',
                                '&:hover': {
                                    bgcolor: 'text.secondary',
                                },
                            },
                        }}>
                        <DayItineraryList
                            formData={formData}
                            setFormData={setFormData}
                            errors={errors}
                            isArabic={isArabic}
                            activeLang={activeLang}
                            hotels={formData.hotels || []}
                        />
                    </Box>
                </Grid>

                {/* Products Panel - Right Side (Sticky) */}
                <Grid item xs={12} md={4}>
                    <Box
                        sx={{
                            position: 'sticky',
                            top: 80, // Same as left side
                            maxHeight: 'calc(100vh - 100px)', // Same dynamic height
                            overflow: 'hidden', // Panel handles its own scroll
                        }}
                    >
                        <ProductsPanel
                            formData={formData}
                            setFormData={setFormData}
                            isArabic={isArabic}
                            activeLang={activeLang}
                        />
                    </Box>
                </Grid>
            </Grid>
        </Paper>
    );
};

export default Step1ProgramData;
